// src/utils/incomeConstants.js
import { AVAILABLE_FISCAL_YEARS } from './fiscalConfig';

/**
 * Types de revenus disponibles
 */
export const INCOME_TYPES = [
  { value: "SALAIRE", label: "Salaire", category: "Activité" },
  { value: "REMUNERATION_DIRIGEANT", label: "Dirigeant de société", category: "Activité", isLinkedToEntity: true, isAutoGenerated: true },
  { value: "MICRO_BIC_VENTE", label: "Micro-BIC Vente", category: "Indépendant" },
  { value: "MICRO_BIC_SERVICE", label: "Micro-BIC Services", category: "Indépendant" },
  { value: "MICRO_BNC", label: "Micro-BNC", category: "Indépendant" },
  { value: "REEL_BIC", label: "BIC Réel", category: "Indépendant" },
  { value: "REEL_BNC", label: "BNC Réel", category: "Indépendant" },
  { value: "LMNP_MICRO", label: "LMNP Micro", category: "Immobilier" },
  { value: "LMNP_REEL", label: "LMNP Réel", category: "Immobilier" },
  { value: "FONCIER_MICRO", label: "Revenus fonciers Micro", category: "Immobilier" },
  { value: "FONCIER_REEL", label: "Revenus fonciers Réel", category: "Immobilier" },
  { value: "CHOMAGE", label: "Allocations chômage", category: "Remplacement" },
  { value: "RETRAITE", label: "Pension de retraite", category: "Remplacement" },
  { value: "SOCIETE_IR", label: "Quote-part société IR", category: "Société" },
  { value: "DIVIDENDES", label: "Dividendes", category: "Société", isLinkedToEntity: true, isAutoGenerated: true },
];

/**
 * Années disponibles (importées depuis fiscalConfig)
 */
export const AVAILABLE_YEARS = AVAILABLE_FISCAL_YEARS;

/**
 * Labels pour les types de revenus
 */
export const INCOME_TYPE_LABELS = INCOME_TYPES.reduce((acc, type) => {
  acc[type.value] = type.label;
  return acc;
}, {});
